import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Card from "@mui/material/Card";
import { Grid } from "@mui/material";
import PlotRenderer from './PlotRenderer';
import axios from 'axios';
import config from "../../../config";
import ChildChart from './ChildChart';
import { duplicated } from './duplicated';
import { dupliethree } from './dupliethree';

const SumoGraphs = () => {


    const { id } = useParams(); // 'id' corresponds to the dynamic route segment

    const categoryA = [54, 66, 69, 75, 88];
    const outliersA = [22, 94];
    const [dataSets, setDataSets] = useState([]);

    const data = [
        {
            y: categoryA,
            type: 'box',
            name: 'Category A',
            boxpoints: false, // Turn off Plotly's outliers
            marker: {
                color: 'blue'
            },
            line: {
                color: 'blue'
            }
        },
        {
            x: Array(outliersA.length).fill('Category A'),
            y: outliersA,
            type: 'scatter',
            mode: 'markers',
            name: 'Outliers',
            marker: {
                symbol: 'circle', // ✅ bullet shape
                size: 8,
                color: 'red'
            },
            hoverinfo: 'y'
        }
    ]

    useEffect(() => {
        if (id) {
            console.log('ID from URL:', id);
            // You can call a function or fetch data with this id here
        }
        try {
            const fetchData = async () => {
                const response = await axios.get(config.MAP_MATCHING_API_URL + `/sumo/run/${id}`, {
                    headers: {
                        'X-API-Key': config.MAP_MATCHING_API_TOKEN
                    }
                });
                const data = response.data;
                const wrapped = Array.isArray(data) ? data : [data];
                setDataSets(wrapped);
                console.log('Fetched data:', response.data);
            }
            fetchData();
            //const data = dupliethree;
            //const data = duplicated; // or dupliethree
            const wrapped = Array.isArray(data) ? data : [data];
            setDataSets(wrapped)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, [id]);


    return (
        <DashboardLayout>
            <Card style={{ marginTop: '3px', padding: '12px', height: '100%' }}>
                <Grid container spacing={3}>
                    {dataSets.map((entry) => (
                        <ChildChart key={entry.id} data={entry} />
                    ))}


                </Grid>
            </Card>
        </DashboardLayout>
    );
};

export default SumoGraphs;